import { LANGUAGE_LABELS, SUPPORTED_LANGUAGES, type SupportedLanguage } from '@/lib/i18n';
import { useI18nStore } from '@/stores/i18n.store';
import { cn } from '@/lib/utils';

interface LanguageSwitcherProps {
  /** Visual size variant */
  size?: 'sm' | 'md';
  /** Additional CSS classes */
  className?: string;
}

export function LanguageSwitcher({ size = 'md', className }: LanguageSwitcherProps) {
  const { language, setLanguage } = useI18nStore();

  return (
    <div
      className={cn(
        'inline-flex items-center rounded-lg border border-border bg-muted p-0.5 gap-0.5',
        className
      )}
      role="group"
      aria-label="Language selector"
    >
      {SUPPORTED_LANGUAGES.map((lang: SupportedLanguage) => {
        const isActive = language === lang;
        return (
          <button
            key={lang}
            onClick={() => setLanguage(lang)}
            className={cn(
              'rounded-md font-medium transition-all duration-150 select-none',
              size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-3 py-1 text-sm',
              isActive
                ? 'bg-background text-foreground shadow-sm'
                : 'text-muted-foreground hover:text-foreground hover:bg-background/60'
            )}
            aria-pressed={isActive}
            title={lang === 'en' ? 'English' : lang === 'ur' ? 'اردو (Urdu)' : 'Roman Urdu'}
          >
            {LANGUAGE_LABELS[lang]}
          </button>
        );
      })}
    </div>
  );
}
